export default "__VITE_ASSET__afcacd13__"